// --------------------------------------------------------------
// Created On: 2025-11-19
// Author: Marco Serrano
//
// Last Modified: 2025-11-19
// Modified By: Marco Serrano
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import {
  getChristmas,
  getEaster,
  getIndependenceDay,
  getLaborDay,
  getMemorialDay,
  getNewYearsDay,
  getThanksgiving,
} from "date-fns-holiday-us";
import { addDays } from "date-fns";
import getDateAsPacific from "./getDateAsPacific";

// Function to calculate if a given date falls on a holiday or a weekend and adds days until it no longer does.
export default function addBusinessDays(isoUtc: string) {
  const date = new Date(isoUtc);
  const currentYear = date.getFullYear();
  const nextYear = date.getFullYear() + 1;
  const thanksgiving = getDateAsPacific(getThanksgiving(currentYear));
  const dayAfterThanksgiving = addDays(thanksgiving, 1);
  const nextThanksgiving = getDateAsPacific(getThanksgiving(nextYear));
  const dayAfterThanksgivingNextYear = addDays(nextThanksgiving, 1);
  const christmas = getDateAsPacific(getChristmas(currentYear));
  const dayAfterChristmas = addDays(christmas, 1);
  const nextChristmas = getDateAsPacific(getChristmas(nextYear));
  const dayAfterChristmasNextYear = addDays(nextChristmas, 1);
  const holidays = [
    christmas.toISOString(),
    dayAfterChristmas.toISOString(),
    getDateAsPacific(getEaster(currentYear)).toISOString(),
    thanksgiving.toISOString(),
    dayAfterThanksgiving.toISOString(),
    getDateAsPacific(getLaborDay(currentYear)).toISOString(),
    getDateAsPacific(getMemorialDay(currentYear)).toISOString(),
    getDateAsPacific(getIndependenceDay(currentYear)).toISOString(),
    getDateAsPacific(getNewYearsDay(currentYear)).toISOString(),
    nextChristmas.toISOString(),
    dayAfterChristmasNextYear.toISOString(),
    getDateAsPacific(getEaster(nextYear)).toISOString(),
    nextThanksgiving.toISOString(),
    dayAfterThanksgivingNextYear.toISOString(),
    getDateAsPacific(getLaborDay(nextYear)).toISOString(),
    getDateAsPacific(getMemorialDay(nextYear)).toISOString(),
    getDateAsPacific(getIndependenceDay(nextYear)).toISOString(),
    getDateAsPacific(getNewYearsDay(nextYear)).toISOString(),
  ];
  // Gets if a specific date is a holiday using UTC time.
  const isHoliday = (date: Date) => holidays.includes(date.toISOString());

  // Gets the day of the week based on UTC time. 0 is Sunday and 6 is Saturday.
  const isWeekend = (date: Date) => {
    return date.getUTCDay() === 0 || date.getUTCDay() === 6;
  };
  // Add days until the date no longer falls on a weekend or holiday.
  while (isWeekend(date) || isHoliday(date)) {
    date.setDate(date.getDate() + 1);
  }
  return date.toISOString();
}
